import Link from 'next/link'
import { Button } from '@/components/ui/button'

interface Category {
  label: string
  value: string
  mainCategory: string
}

const categories: Category[] = [
  { label: '웹·앱 개발', value: 'web-app', mainCategory: '웹 개발' },
  { label: 'DevOps·인프라', value: 'devops', mainCategory: '인프라/클라우드/보안' },
  { label: 'AI·데이터 분석', value: 'ai-data', mainCategory: '인공지능(AI)/데이터' },
  { label: '데이터 엔지니어링', value: 'etl', mainCategory: '인공지능(AI)/데이터' },
  { label: 'UI/UX 디자인', value: 'ui-ux', mainCategory: '디자인/미디어' },
  { label: '서비스 기획(PM)', value: 'pm', mainCategory: '기획/PM' },
]

interface ClientExploreCategoriesProps {
  isVisible: boolean
  buildLoginRedirect: (target: string) => string
}

export default function ClientExploreCategories({ isVisible, buildLoginRedirect }: ClientExploreCategoriesProps) {
  const getCategoryHref = (category: Category) => {
    const params = new URLSearchParams({
      category: category.value,
      mainCategory: category.mainCategory,
      forcePrefill: '1',
      from: 'landing_category_chip',
    })
    return buildLoginRedirect(`/client/projects/new?${params.toString()}`)
  }

  const directInputHref = buildLoginRedirect('/client/projects/new?from=landing_category_direct')
  const primaryCtaHref = buildLoginRedirect('/client/projects/new?from=landing_category_primary')

  return (
    <section
      className={`w-full bg-white px-4 py-16 sm:px-6 md:py-20 lg:px-8 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="mx-auto max-w-5xl">
        <div className="mb-8 text-center">
          <h2 className="mb-3 text-3xl font-bold text-gray-900 md:text-4xl">
            어떤 프로젝트인가요?
          </h2>
          <p className="text-sm text-gray-500">
            자주 요청되는 상위 6개 카테고리입니다. 없으면 직접 입력으로 진행하세요
          </p>
        </div>

        {/* 칩 그리드 */}
        <div className="mb-8 flex flex-wrap items-center justify-center gap-4">
          {categories.map((category, index) => (
            <Link
              key={category.value}
              href={getCategoryHref(category)}
              className={`inline-flex items-center gap-2 rounded-full bg-gray-100 px-5 py-2.5 text-sm font-medium text-gray-700 transition-all duration-200 hover:bg-blue-50 hover:text-blue-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{
                transitionDelay: isVisible ? `${index * 50}ms` : '0ms',
              }}
            >
              <span>{category.label}</span>
            </Link>
          ))}
          {/* 더보기 링크 */}
          <Link
            href={directInputHref}
            className={`inline-flex items-center rounded-full px-5 py-2.5 text-sm font-medium text-gray-600 transition-all duration-200 hover:text-blue-600 hover:bg-blue-50 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
            style={{
              transitionDelay: isVisible ? `${categories.length * 50}ms` : '0ms',
            }}
          >
            직접 입력하기
          </Link>
        </div>

        {/* CTA 버튼 */}
        <div className="flex items-center justify-center pt-4">
          <Button
            asChild
            size="lg"
            className="h-12 rounded-xl bg-blue-600 px-6 text-white shadow-md transition-all hover:bg-blue-700 hover:shadow-lg font-semibold whitespace-nowrap w-auto"
          >
            <Link href={primaryCtaHref}>
              무료로 견적 요청 시작하기
            </Link>
          </Button>
        </div>
      </div>
    </section>
  )
}

